module.exports = __webpack_public_path__ + "img/borescope_protoype4.660d59b6.jpg";